"use client";

import { useState, useEffect } from "react";
import "./Navbar.css";
import logo from "../assets/ABM Logo.png";

const Navbar = ({ activeSection, setActiveSection, scrollY }) => {
  const [menuOpen, setMenuOpen] = useState(false);

  const navLinks = [
    { id: "home", label: "Home" },
    { id: "about", label: "About Us" },
    { id: "products", label: "Products" },
    { id: "why-choose-us", label: "Why Choose Us" },
    { id: "faq", label: "FAQ" },
    { id: "blog", label: "Blog" },
    { id: "contact", label: "Contact" },
  ];

  useEffect(() => {
    const sections = document.querySelectorAll("section");

    const handleScroll = () => {
      let current = "";

      sections.forEach((section) => {
        const sectionTop = section.offsetTop;
        const sectionHeight = section.clientHeight;

        if (
          scrollY >= sectionTop - 200 &&
          scrollY < sectionTop + sectionHeight - 200
        ) {
          current = section.getAttribute("id");
        }
      });

      if (current && current !== activeSection) {
        setActiveSection(current);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [scrollY, activeSection, setActiveSection]);

  const handleNavClick = (id) => {
    setActiveSection(id);
    setMenuOpen(false);
    document.getElementById(id).scrollIntoView({ behavior: "smooth" });
  };

  return (
    <nav className={`navbar ${scrollY > 50 ? "navbar-scrolled" : ""}`}>
      <div className="container navbar-container">
        <div className="navbar-logo">
          <a href="#home" onClick={() => handleNavClick("home")}>
            <img src={logo} alt="ABM Metal Tech Logo" className="logo-image" />
            <span className="logo-text">ABM Metal Tech</span>
          </a>
        </div>

        <div className={`navbar-menu ${menuOpen ? "active" : ""}`}>
          <ul className="navbar-links">
            {navLinks.map((link) => (
              <li
                key={link.id}
                className={activeSection === link.id ? "active" : ""}
              >
                <a href={`#${link.id}`} onClick={() => handleNavClick(link.id)}>
                  {link.label}
                </a>
              </li>
            ))}
          </ul>
          <a
            href="#contact"
            className="btn navbar-cta"
            onClick={() => handleNavClick("contact")}
          >
            <span className="navbar-cta-text">Get a Quote</span>
            <span className="sparks-animation">
              <span data-spark="1"></span>
              <span data-spark="2"></span>
              <span data-spark="3"></span>
              <span data-spark="4"></span>
              <span data-spark="5"></span>
              <span data-spark="6"></span>
              <span data-spark="7"></span>
              <span data-spark="8"></span>
            </span>
          </a>
        </div>

        <div
          className={`navbar-toggle ${menuOpen ? "active" : ""}`}
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
